<script setup lang="ts">
const { jwt } = useLocalStorage()

const url = `https://locator.heypongo.com/admin?token=${jwt.value}`
</script>

<template>
  <div class="h-screen">
    <iframe
      class="h-full w-full"
      :src="url"
      frameborder="0"
      sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation allow-downloads allow-popups"
      allow="clipboard-write"
    />
  </div>
</template>
